import React from 'react';

export default function TabelaProdutos({ produtos, onEntrada, onSaida, onDelete }) {
  if (produtos.length === 0) return <div className="mt"><span className="mt-ico">📦</span>Nenhum produto cadastrado.</div>;

  return (
    <div className="lst">
      {produtos.map((p) => {
        const estoqueBaixo = p.quantidade <= 3;
        const margem = Number(p.preco) - Number(p.preco_custo);
        return (
          <div key={p.id} className="it">
            <div className="it-main">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <strong style={{ fontSize: 14 }}>{p.nome}</strong>
                <span className={`bd ${estoqueBaixo ? 'bd-r' : 'bd-g'}`}>{p.quantidade} un.</span>
              </div>
              {p.descricao && <div style={{ fontSize: 11, color: 'var(--c4)', marginTop: 2 }}>{p.descricao}</div>}
              <div style={{ display: 'flex', gap: 12, marginTop: 4, fontSize: 11, color: 'var(--c4)', flexWrap: 'wrap' }}>
                <span>Custo <strong>R$ {Number(p.preco_custo).toFixed(2)}</strong></span>
                <span>Venda <strong style={{ color: 'var(--g)' }}>R$ {Number(p.preco).toFixed(2)}</strong></span>
                <span>Margem <strong style={{ color: margem >= 0 ? 'var(--g)' : 'var(--r)' }}>R$ {margem.toFixed(2)}</strong></span>
              </div>
            </div>
            <div className="btn-g" style={{ flexShrink: 0 }}>
              <button className="btn btn1 btn-sm" onClick={() => onEntrada(p)} title="Estoque">+</button>
              <button className="btn btn2 btn-sm" onClick={() => onSaida(p)} disabled={p.quantidade === 0} title="Venda">-</button>
              <button className="btn btn3 btn-sm" onClick={() => onDelete(p)} title="Excluir">x</button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
